import { useTranslate } from '@ur-solutions/react-hooks'
import type { ComboboxCommonProps, ComboboxItem } from './combobox'
import { Combobox } from './combobox'

// There is an AbsenceStatusValue enum defined in @/modules/timesheets/consts,
// but this seem to contain the wrong values (they should be lowercase)

export enum AbsenceStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  REJECTED = 'rejected',
}

interface CommonProps extends ComboboxCommonProps {
  exclude?: AbsenceStatus[]
}

interface SingleProps extends CommonProps {
  mode: 'single'
  value: AbsenceStatus | ''
  onChange(value: AbsenceStatus | ''): void
}

interface MultiProps extends CommonProps {
  mode: 'multiple'
  value: AbsenceStatus[]
  onChange(value: AbsenceStatus[]): void
}

type Props = SingleProps | MultiProps

export function AbsenceStatusCombobox({
  mode,
  value,

  exclude = [],

  placeholder,
  searchPlaceholder,
  noResultsText,

  onChange,

  ...props
}: Props) {
  const translations = useTranslate({
    approved: 'timesheets.absence-approved',
    pending: 'timesheets.absence-pending',
    rejected: 'timesheets.absence-rejected',

    single: {
      placeholder: 'components.combobox.absence-status.placeholder',
    },
    multiple: {
      placeholder: 'components.multi-combobox.absence-status.placeholder',
    },
  })

  const absenceStatusItems: ComboboxItem<AbsenceStatus>[] = (() => {
    const items: ComboboxItem<AbsenceStatus>[] = [
      {
        value: AbsenceStatus.APPROVED,
        label: translations.approved,
      },
      {
        value: AbsenceStatus.PENDING,
        label: translations.pending,
      },
      {
        value: AbsenceStatus.REJECTED,
        label: translations.rejected,
      },
    ].filter(item => !exclude.includes(item.value))

    return items
  })()

  if (mode === 'single')
    return (
      <Combobox
        {...props}
        mode="single"
        value={value}
        items={absenceStatusItems}
        clearable
        noSearch
        placeholder={placeholder ?? translations.single.placeholder}
        onChange={onChange}
      />
    )

  return (
    <Combobox
      {...props}
      mode="multiple"
      value={value}
      items={absenceStatusItems}
      noSearch
      placeholder={placeholder ?? translations.multiple.placeholder}
      onChange={onChange}
    />
  )
}
